import Vue from 'vue';
import Snackbar from '@/utils/Snackbar';

Vue.prototype.$snackbar = Snackbar;
